function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard-Copy-8",
  transform: "translate(-38.000000, -49.000000)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M274.367862,49 C346.290162,49 407.561426,94.6025027 430.844603,158.470455 L473.076964,182.85568 L447.168147,227.731597 C447.54867,234.099818 447.526452,240.420233 447.120597,246.660791 C446.452961,345.867906 381.056155,434.381932 283.95665,456.799119 C181.168958,480.529527 77.8425537,422.114837 38,323.451766 C46.0288399,325.559273 54.1358681,327.4033 62.3097138,328.976427 C55.3107887,311.777965 50.2459433,293.41489 47.4166387,274.224731 C75.1737367,289.675829 104.977824,301.316147 136.26189,308.522863 C118.333083,281.964316 107.867862,249.9543 107.867862,215.5 C107.867862,123.544589 182.412451,49 274.367862,49 Z M362.333891,95.7030046 C335.326979,82.9786176 305.574437,149.225664 305.574437,196.42675 C305.574437,243.627836 311.728898,310.005573 362.333891,296.277202 C412.938884,282.54883 415.71246,217.920101 414.325672,186.312232 C413.899908,176.608148 411.38055,165.521383 407.311529,154.44734 C404.912502,164.135804 398.932247,171 391.934565,171 C382.821866,171 375.434565,159.359403 375.434565,145 C375.434565,132.358754 381.159793,121.82461 388.747897,119.483986 C380.910385,108.80496 371.832996,100.178536 362.333891,95.7030046 Z",
  id: "Combined-Shape"
})));

var SvgBudgie = function SvgBudgie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "436px",
    height: "414px",
    viewBox: "0 0 436 414",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBudgie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/budgie.47bebd6e.svg";
export { ForwardRef as ReactComponent };